import * as types from './ServicesTypes';

export default function ServicesReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_SERVICES:
            return {
                ...state,
                getServices: {
                    ...state.getServices,
                    services: payload.data,
                    firstService: payload.first,
                    lastService: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_SERVICES_LOADING:
            return {
                ...state,
                getServices: {
                    ...state.getServices,
                    loading: true
                },
            };
        case types.GET_SERVICES_ERROR:
            return {
                ...state,
                getServices: {
                    ...state.getServices,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_SERVICES:
            return {
                ...state,
                createServices: {
                    ...state.createServices,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_SERVICES_LOADING:
            return {
                ...state,
                createServices: {
                    ...state.createServices,
                    loading: true,
                },
            };
        case types.CREATE_SERVICES_ERROR:
            return {
                ...state,
                createServices: {
                    ...state.createServices,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_SERVICES_BY_ID:
            return {
                ...state,
                updateServicesById: {
                    ...state.updateServicesById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
        case types.UPDATE_SERVICES_BY_ID_LOADING:
            return {
                ...state,
                updateServicesById: {
                    ...state.updateServicesById,
                    loading: true,
                }
            };
        case types.UPDATE_SERVICES_BY_ID_ERROR:
            return {
                ...state,
                updateServicesById: {
                    ...state.updateServicesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                }
            };
        case types.GET_CATEGORIES_SERVICES:
            return {
                ...state,
                getCategoriesServices: {
                    ...state.getCategoriesServices,
                    categoriesServices: payload.data,
                    firstCategoryService: payload.first,
                    lastCategoryService: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CATEGORIES_SERVICES_LOADING:
            return {
                ...state,
                getCategoriesServices: {
                    ...state.getCategoriesServices,
                    loading: true
                },
            };
        case types.GET_CATEGORIES_SERVICES_ERROR:
            return {
                ...state,
                getCategoriesServices: {
                    ...state.getCategoriesServices,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CATEGORIES_SERVICES_BY_ID:
                return {
                    ...state,
                    getCategoriesServicesById: {
                        ...state.getCategoriesServicesById,
                        categoryService: payload.data,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.GET_CATEGORIES_SERVICES_BY_ID_LOADING:
                return {
                    ...state,
                    getCategoriesServicesById: {
                        ...state.getCategoriesServicesById,
                        loading: true
                    },
                };
            case types.GET_CATEGORIES_SERVICES_BY_ID_ERROR:
                return {
                    ...state,
                    getCategoriesServicesById: {
                        ...state.getCategoriesServicesById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    },
                };
            case types.CREATE_CATEGORIES_SERVICES:
                return {
                    ...state,
                    createCategoriesServices: {
                        ...state.createCategoriesServices,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                };
            case types.CREATE_CATEGORIES_SERVICES_LOADING:
                return {
                    ...state,
                    createCategoriesServices: {
                        ...state.createCategoriesServices,
                        loading: true
                    },
                };
            case types.CREATE_CATEGORIES_SERVICES_ERROR:
                return {
                    ...state,
                    createCategoriesServices: {
                        ...state.createCategoriesServices,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        },
                    },
                };
            case types.CREATE_CATEGORIES_SERVICES_RESET_STATE:
                return {
                    ...state,
                    createCategoriesServices: {
                        ...state.createCategoriesServices,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.UPDATE_CATEGORIES_SERVICES_BY_ID:
                return {
                    ...state,
                    updateCategoriesServicesById: {
                        ...state.updateCategoriesServicesById,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    }
                };
            case types.UPDATE_CATEGORIES_SERVICES_BY_ID_LOADING:
                return {
                    ...state,
                    updateCategoriesServicesById: {
                        ...state.updateCategoriesServicesById,
                        loading: true,
                    }
                };
            case types.UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR:
                return {
                    ...state,
                    updateCategoriesServicesById: {
                        ...state.updateCategoriesServicesById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    }
                };
            case types.GET_SUBCATEGORIES_SERVICES_BY_ID:
                return {
                    ...state,
                    getSubCategoriesServicesById: {
                        ...state.getSubCategoriesServicesById,
                        subCategoriesServices: payload.data,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.GET_SUBCATEGORIES_SERVICES_BY_ID_LOADING:
                return {
                    ...state,
                    getSubCategoriesServicesById: {
                        ...state.getSubCategoriesServicesById,
                        loading: true
                    },
                };
            case types.GET_SUBCATEGORIES_SERVICES_BY_ID_ERROR:
                return {
                    ...state,
                    getSubCategoriesServicesById: {
                        ...state.getSubCategoriesServicesById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    },
                }; 
            case types.CREATE_SUBCATEGORIES_SERVICES:
                return {
                    ...state,
                    createSubCategoriesServices: {
                        ...state.createSubCategoriesServices,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                };
            case types.CREATE_SUBCATEGORIES_SERVICES_LOADING:
                return {
                    ...state,
                    createSubCategoriesServices: {
                        ...state.createSubCategoriesServices,
                        loading: true
                    },
                };
            case types.CREATE_SUBCATEGORIES_SERVICES_ERROR:
                return {
                    ...state,
                    createSubCategoriesServices: {
                        ...state.createSubCategoriesServices,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        },
                    },
                };
            case types.UPDATE_CATEGORIES_SERVICES_RESET_STATE:
                return {
                    ...state,
                    updateCategoriesServicesById: {
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
    
        default:
            return state;
    }
}